import React from 'react'
import { useInView } from 'react-intersection-observer'
import CountUp from 'react-countup'

const Counter = () => {

    const { ref, inView } = useInView({
        triggerOnce: true,
        // Niedrigerer Threshold, damit der Counter auch auf kleinen
        // Bildschirmen zuverlässig auslöst, wenn nicht 60% sichtbar werden können.
        threshold: 0.3,
        // Etwas früher triggern, sobald das Element nahe am Viewport ist
        rootMargin: '0px 0px -10% 0px'
    });

    return (
        <div ref={ref} aria-live="polite">
            {inView ? (
                <CountUp
                    className='counter'
                    start={0}
                    separator="."
                    end={532000}
                    duration={1.75}
                    useEasing={true}
                />
            ) : (
                // Platzhalter um Layout-Shift zu vermeiden
                <span className='counter' aria-hidden="true">0</span>
            )}
        </div>
    );
}

export default Counter;